/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { DeleteAdminCompetitionResponse, DeleteAdminCompetitionVars } from '../openapi-types.gen.js';

export type { DeleteAdminCompetitionResponse, DeleteAdminCompetitionVars } from '../openapi-types.gen.js';

export const useDeleteAdminCompetition = createMutationHook<DeleteAdminCompetitionVars, DeleteAdminCompetitionResponse, unknown>({
  specName: 'useDeleteAdminCompetition',
  path: '/v1/admin/competitions/{competitionId}',
  method: 'DELETE',
  resolveUrl: (vars: DeleteAdminCompetitionVars) => `/v1/admin/competitions/${vars.competitionId}`,
  
  parseResponse: (raw: unknown): DeleteAdminCompetitionResponse => raw as DeleteAdminCompetitionResponse,
  optimistic: [{
    queryKey: ['admin', 'list'],
    apply: (prev: any, vars: DeleteAdminCompetitionVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
